"use strict";

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/opt/build/repo/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/build/repo/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/opt/build/repo/node_modules/@babel/runtime/helpers/inherits");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var abstractmessage_1 = require("./abstractmessage");

var Init =
/*#__PURE__*/
function (_abstractmessage_1$Ab) {
  _inherits(Init, _abstractmessage_1$Ab);

  function Init(token, continuationToken, metadata) {
    var _this;

    var registrations = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    var tweaks = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;

    _classCallCheck(this, Init);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Init).call(this));
    _this.method = 'init';
    _this.token = token;
    _this.continuation_token = continuationToken;
    _this.metadata = metadata;
    _this.registrations = registrations;
    _this.tweaks = tweaks;
    _this.capabilities = ['client_update', 'offline_storage'];
    return _this;
  }

  return Init;
}(abstractmessage_1.AbstractMessage);

exports.Init = Init;